"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _underscore = require("FileManagerCore/vendor/underscore.custom");

var _immutable = _interopRequireDefault(require("immutable"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _Constants = require("FileManagerCore/Constants");

var _Constants2 = require("FileManagerLib/Constants");

var Actions = _interopRequireWildcard(require("FileManagerLib/actions/Actions"));

var _FoldersAndFilesContainer = _interopRequireDefault(require("FileManagerLib/containers/browser/FoldersAndFilesContainer"));

var _EmptySearchResults = _interopRequireDefault(require("FileManagerLib/components/browser/EmptySearchResults"));

var _Tiles = require("FileManagerLib/selectors/Tiles");

var _Shutterstock = require("FileManagerLib/actions/Shutterstock");

var _Shutterstock2 = _interopRequireDefault(require("FileManagerLib/components/browser/Shutterstock"));

var _ShutterstockTOS = _interopRequireDefault(require("FileManagerLib/components/browser/ShutterstockTOS"));

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var _Auth = require("FileManagerLib/selectors/Auth");

var _Files = require("FileManagerCore/selectors/Files");

var _Tiles2 = require("FileManagerLib/utils/Tiles");

var _network = require("FileManagerLib/utils/network");

var SearchPanel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SearchPanel, _Component);

  function SearchPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SearchPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SearchPanel).call(this, props));
    _this.handleSearch = _this.handleSearch.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLoadMoreRows = _this.handleLoadMoreRows.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLoadMoreStockImages = _this.handleLoadMoreStockImages.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetch = _this.fetch.bind((0, _assertThisInitialized2.default)(_this));
    _this.debouncedFetch = (0, _underscore.debounce)(_this.fetch, 500);
    return _this;
  }

  (0, _createClass2.default)(SearchPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          searchQuery = _this$props.searchQuery,
          onTrackInteraction = _this$props.onTrackInteraction,
          type = _this$props.type;
      onTrackInteraction('Browse Shutterstock', 'started-search');
      this.fetch({
        initial: true,
        searchQuery: searchQuery,
        page: 1,
        pageSize: _Constants2.PAGE_SIZE,
        type: type
      });
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
          fetchFiles = _this$props2.fetchFiles,
          fetchStockFiles = _this$props2.fetchStockFiles,
          type = _this$props2.type,
          isShutterstockEnabled = _this$props2.isShutterstockEnabled;
      fetchFiles((0, _extends2.default)({}, options, {
        type: type
      }));

      if (isShutterstockEnabled && type === _Constants2.DrawerTypes.IMAGE) {
        fetchStockFiles((0, _extends2.default)({}, options, {
          type: type
        }));
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(event) {
      var _this$props3 = this.props,
          onSearch = _this$props3.onSearch,
          type = _this$props3.type;
      var searchQuery = event.target.value;
      this.debouncedFetch({
        initial: true,
        searchQuery: searchQuery,
        page: 1,
        pageSize: _Constants2.PAGE_SIZE,
        type: type
      });
      onSearch(searchQuery);
    }
  }, {
    key: "handleLoadMoreRows",
    value: function handleLoadMoreRows() {
      var _this$props4 = this.props,
          status = _this$props4.status,
          files = _this$props4.files,
          fetchFiles = _this$props4.fetchFiles,
          searchQuery = _this$props4.searchQuery,
          type = _this$props4.type;

      if (status === _Constants.RequestStatus.PENDING) {
        return;
      }

      fetchFiles({
        offset: files.count(),
        type: type,
        searchQuery: searchQuery
      });
    }
  }, {
    key: "handleLoadMoreStockImages",
    value: function handleLoadMoreStockImages() {
      var _this$props5 = this.props,
          stockImages = _this$props5.stockImages,
          fetchStockFiles = _this$props5.fetchStockFiles,
          searchQuery = _this$props5.searchQuery,
          type = _this$props5.type,
          stockStatus = _this$props5.stockStatus;

      if (stockStatus === _Constants.RequestStatus.PENDING) {
        return;
      }

      var page = Math.ceil(stockImages.size / _Constants2.PAGE_SIZE) + 1;
      fetchStockFiles({
        searchQuery: searchQuery,
        page: page,
        pageSize: _Constants2.PAGE_SIZE,
        type: type
      });
    }
  }, {
    key: "renderTiles",
    value: function renderTiles() {
      var _this$props6 = this.props,
          type = _this$props6.type,
          total = _this$props6.total,
          tiles = _this$props6.tiles,
          status = _this$props6.status,
          onInsert = _this$props6.onInsert;

      if (status === _Constants.RequestStatus.SUCCEEDED && total === 0) {
        return _react.default.createElement(_EmptySearchResults.default, null);
      }

      return _react.default.createElement(_FoldersAndFilesContainer.default, {
        type: type,
        tiles: tiles,
        total: total,
        onInsert: onInsert,
        onLoadMoreFiles: this.handleLoadMoreRows
      });
    }
  }, {
    key: "renderShutterstockTiles",
    value: function renderShutterstockTiles() {
      var _this$props7 = this.props,
          stockStatus = _this$props7.stockStatus,
          stockTiles = _this$props7.stockTiles,
          stockTotal = _this$props7.stockTotal,
          onInsert = _this$props7.onInsert;

      if (stockStatus === _Constants.RequestStatus.SUCCEEDED && stockTotal === 0) {
        return _react.default.createElement(_EmptySearchResults.default, null);
      }

      return _react.default.createElement(_Shutterstock2.default, {
        tiles: stockTiles,
        total: stockTotal,
        onInsert: onInsert,
        onLoadMoreImages: this.handleLoadMoreStockImages
      });
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      return _react.default.createElement(_UITabs.default, {
        defaultSelected: "files",
        className: "search-panel__tab-growth-fix",
        panelClassName: "search-panel__tab-growth-fix p-x-0 flex"
      }, _react.default.createElement(_UITab.default, {
        tabId: "files",
        title: _I18n.default.text('FileManagerLib.panels.tabs.files')
      }, this.renderTiles()), _react.default.createElement(_UITab.default, {
        tabId: "shutterstock",
        title: _I18n.default.text('FileManagerLib.panels.tabs.shutterstock.heading')
      }, _react.default.createElement(_ShutterstockTOS.default, {
        use: "light"
      }), this.renderShutterstockTiles()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          searchQuery = _this$props8.searchQuery,
          onBack = _this$props8.onBack,
          isShutterstockEnabled = _this$props8.isShutterstockEnabled,
          type = _this$props8.type;
      return _react.default.createElement(_UIFlex.default, {
        direction: "column"
      }, _react.default.createElement(_UISearchInput.default, {
        className: "m-top-3",
        value: searchQuery,
        onChange: this.handleSearch
      }), _react.default.createElement(_UIBackButton.default, {
        className: "search-panel__back-button m-top-6 m-bottom-4"
      }, _react.default.createElement(_UILink.default, {
        onClick: onBack
      }, _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.backButton')))), _react.default.createElement(_UIBox.default, {
        className: "flex-column",
        grow: 1,
        alignSelf: "stretch"
      }, _react.default.createElement("h5", null, _I18n.default.text('FileManagerLib.panels.searchResults', {
        term: searchQuery
      })), isShutterstockEnabled && type === _Constants2.DrawerTypes.IMAGE ? this.renderTabs() : this.renderTiles()));
    }
  }]);
  return SearchPanel;
}(_react.Component);

SearchPanel.propTypes = {
  type: _react.PropTypes.oneOf(Object.keys(_Constants2.DrawerTypes)).isRequired,
  files: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
  tiles: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
  stockTiles: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
  status: _react.PropTypes.oneOf(Object.keys(_Constants.RequestStatus)),
  stockStatus: _react.PropTypes.oneOf(Object.keys(_Constants.RequestStatus)),
  total: _react.PropTypes.number.isRequired,
  stockTotal: _react.PropTypes.number.isRequired,
  searchQuery: _react.PropTypes.string.isRequired,
  stockImages: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
  fetchFiles: _react.PropTypes.func.isRequired,
  fetchStockFiles: _react.PropTypes.func.isRequired,
  onSearch: _react.PropTypes.func.isRequired,
  onInsert: _react.PropTypes.func.isRequired,
  onBack: _react.PropTypes.func.isRequired,
  isShutterstockEnabled: _react.PropTypes.bool.isRequired,
  onTrackInteraction: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, props) {
  var shutterstock = state.shutterstock,
      panel = state.panel;
  var stockTiles = (0, _Tiles.getStockTiles)(state, props);
  var files = (0, _Files.getFiles)(state);
  var tiles = (0, _Tiles.getSearchTiles)(state, props);
  return {
    files: files,
    total: (0, _Tiles2.getTotalFilteredTiles)({
      savedFilesCount: (0, _Files.getFilesTotal)(state),
      files: files,
      tiles: tiles
    }),
    stockTiles: stockTiles,
    stockTotal: shutterstock.get('total'),
    stockImages: shutterstock.get('results'),
    stockStatus: shutterstock.get('searchStatus'),
    status: (0, _Files.getFetchFilesRequestStatus)(state),
    searchQuery: panel.getIn(['present', 'searchQuery']),
    tiles: tiles,
    isShutterstockEnabled: (0, _Auth.getIsShutterstockEnabled)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onBack: function onBack() {
      dispatch(Actions.goBack());
    },
    onSearch: function onSearch(searchQuery) {
      dispatch(Actions.setSearchQuery(searchQuery));
    },
    onTrackInteraction: function onTrackInteraction(name, action, meta) {
      dispatch(Actions.trackInteraction(name, action, meta));
    },
    fetchFiles: function fetchFiles(_ref) {
      var initial = _ref.initial,
          searchQuery = _ref.searchQuery,
          _ref$offset = _ref.offset,
          offset = _ref$offset === void 0 ? 0 : _ref$offset,
          type = _ref.type;
      var query = (0, _extends2.default)({
        limit: _Constants2.DEFAULT_ROWS_TO_FETCH * _Constants2.IMAGE_COLUMN_COUNT,
        search: searchQuery,
        offset: offset,
        type: type
      }, (0, _network.getProviderParam)(ownProps.type));

      if (initial) {
        dispatch(Actions.fetchInitialFiles(query, ownProps.type));
      } else {
        dispatch(Actions.fetchMoreFiles(query, ownProps.type));
      }
    },
    fetchStockFiles: function fetchStockFiles(query) {
      var searchQuery = query.searchQuery,
          page = query.page,
          pageSize = query.pageSize,
          initial = query.initial;

      if (initial) {
        dispatch({
          type: _ActionTypes.default.SEARCH_SHUTTERSTOCK_RESET
        });
      }

      dispatch((0, _Shutterstock.searchShutterstock)({
        searchQuery: searchQuery,
        page: page,
        pageSize: pageSize
      }));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchPanel);

exports.default = _default;
module.exports = exports.default;